import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {  useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from "../services/ApiService";
import Loader from "../components/Loader"; 
import ImageUpload from "../components/ImageUpload";

const Account = () => {
  const navigate = useNavigate();
  const user= JSON.parse(localStorage.getItem('user'));

  const [tab, setTab] = useState("email");
  const [email, setEmail] = useState(user.email);
  const [username, setUsername] = useState(user.username);
  const [picture, setPicture] = useState(user.picture);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoader, setIsLoader] = useState(false);



const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoader(true);
    try {
        const formData = {
            "email": email,
            "username": username,
            "old_password": oldPassword,
            "new_password": newPassword,
            "confirm_password": confirmPassword,
          };
        console.log(formData);

        const response = await ApiService.request({
            method: "POST",
            url: "updateAccount", 
            data:formData
        });
        const data = response.data;
        if (data.status) {
            user.email=email;
            console.log(user);
            localStorage.setItem('user', JSON.stringify(user));
            toast.success(data.message);
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        console.log(error);

        setIsLoader(false);
    }
   
};
  const handleImageChange = (name, file) => {
    if (name === 'picture') {
      setPicture(file);
      if (file) {
        setPicture(URL.createObjectURL(file));
      } else {
        setPicture(null);
      }
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        Account
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="/TimeLogger/admin/" className="text-muted text-hover-primary">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted">Account</li>
                    </ul>
                </div>
                <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
            </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="card">
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                            className={`nav-link fs-lg-5 ${tab === "email" ? "active" : ""}`}
                            onClick={() => setTab("email")}
                            id="nav-profile-tab"
                            type="button"
                        >
                            <i className="fas faenvelope"></i> Account Info
                        </button>
                        <button
                            className={`nav-link fs-lg-5 ${tab === "password" ? "active" : ""}`}
                            onClick={() => setTab("password")}
                            id="nav-contact-tab"
                            type="button"
                        >
                            <i className="fas fakey"></i> Change Password
                        </button>
                        </div>
                    </nav>
                    <div className="card-body pt-0">
                        <div className="mb-8 text-center"></div>
                        <div className="row g-9 mb-8">
                        <div className="col-md-12">
                            <div className="tab-content mt-5" id="nav-tabContent">
                            {tab === "email" && (
                                <div className="tab-pane fade show active">
                                <form className="form" onSubmit={handleSubmit}>
                                    <div className="d-flex my-3 flex-column">
                                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                            <span className="required">Username</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            className="form-control form-control-solid"
                                            placeholder="Enter Username"
                                        />
                                    </div>
                                    <div className="d-flex my-3 flex-column">
                                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                            <span className="required">Email</span>
                                        </label>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="form-control form-control-solid"
                                            placeholder="Enter Email"
                                        />
                                    </div>
                                    <div className="col-md-6 my-3 fv-row fv-plugins-icon-container">
                                        <label className="fs-6 fw-semibold mb-2">Image</label>
                                        <ImageUpload name="picture" onImageChange={handleImageChange} defaultPreviewUrl={picture} />
                                    </div>
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Update Email Address</Tooltip>}>
                                        <button
                                        type="submit"
                                        className="btn btn-base my-5"
                                        disabled={isLoader}
                                        >
                                        <span className="indicator-label">
                                            {!isLoader ? "Update Email" : <Loader size="20" text="Updating" />}
                                        </span>
                                        </button>
                                    </OverlayTrigger>
                                </form>
                                </div>
                            )}
                            {tab === "password" && (
                                <div className="tab-pane fade show active">
                                <form className="form" onSubmit={handleSubmit}>
                                    <div className="row">
                                    <div className="col-md-12">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        Current Password
                                        </label>
                                        <input
                                        type="password" required
                                        className="form-control form-control-solid"
                                        placeholder="Enter Your Old Password"
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                        />
                                        <br />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        New Password
                                        </label>
                                        <input required
                                        type="password"
                                        className="form-control form-control-solid"
                                        placeholder="Enter New Password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        Confirm Password
                                        </label>
                                        <input
                                        type="password" required
                                        className="form-control form-control-solid"
                                        placeholder="Enter Confirm Password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                    </div>
                                    </div>
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Update Password</Tooltip>}>
                                        <button
                                        type="submit"
                                        className="btn btn-base my-5"
                                        disabled={isLoader}
                                        >
                                        <span className="indicator-label">
                                            {!isLoader ? "Update Password" : <Loader size="20" text="Updating" />}
                                        </span>
                                        </button>
                                    </OverlayTrigger>
                                </form>
                                </div>
                            )}
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
  );
};

export default Account;
